import type { ReactNode } from "react";

export function Banner({
  kind,
  children,
  onClose,
}: {
  kind: "info" | "error";
  children: ReactNode;
  onClose?: () => void;
}) {
  const cls =
    kind === "error"
      ? "bg-red-50 border-red-200 text-red-800"
      : "bg-emerald-50 border-emerald-200 text-emerald-800";
  return (
    <div className={`flex items-center justify-between border-b px-6 py-2 text-sm ${cls}`}>
      <span>{children}</span>
      {onClose && (
        <button className="opacity-70 hover:opacity-100" onClick={onClose} aria-label="关闭">
          ×
        </button>
      )}
    </div>
  );
}
